import { render, staticRenderFns } from "./Veiculo.vue?vue&type=template&id=13c0cab5"
import script from "./Veiculo.vue?vue&type=script&lang=js"
export * from "./Veiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports